import type { JSX } from 'react';

/**
 * MemberListPage — stub component for the member list route.
 * Full implementation is delivered in Epic 7 (Story 7.1).
 * This stub is needed now so the router auth guard wiring can be tested end-to-end.
 */
export function MemberListPage(): JSX.Element {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-gray-900">Member List</h1>
      <p className="mt-2 text-gray-500">Coming in Epic 7 — member list implementation.</p>
    </div>
  );
}
